import React from 'react';
import styled from 'styled-components';

import { AppState } from '../../store';
import { UserInterface, LabInterface } from '../../store/base/types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Card, DynamicForm, Spin } from '../elements';
import { updateLaboratory } from '../../store/base/functions';

type LabEditComponentProps = {
    className?: string,
    match: any,
    lab: any,
    onUpdate: Function,
    isLoading: boolean
}

const LabEditComponent = (props: LabEditComponentProps) => {
    const handleSubmit = (data : LabInterface) => {
        data['name'] = props.lab.name;
        data = Object.assign({}, data, {
            logo_id : null
        })
        props.onUpdate(data);
    }

    const fields = [
        {
            id: "name",
            htmltype : "text",
            label : "نام آزمایشگاه",
            defaultValue: props.lab.name,
            disabled: true
        },
        {
            id: "doctor",
            htmltype : "text",
            label : "نام مسئول فنی",
            defaultValue: props.lab.doctor,
        },
        {
            id: "city",
            htmltype : "text",
            label : "شهر",
            defaultValue: props.lab.city,
        },
        {
            id: "address",
            htmltype : "textarea",
            label : "آدرس",
            defaultValue: props.lab.address,
        },
        {
            id: "phone",
            htmltype : "text",
            label : "تلفن تماس",
            defaultValue: props.lab.phone,
        },
    ]

    return (
      <div className={props.className} style={{marginLeft:20}}>
          {props.lab &&
            <Card
              title={"ویرایش اطلاعات آزمایشگاه"}
            >
                <Spin active={props.isLoading}>
                    <div style={{padding:'20px'}}>
                        <DynamicForm fields={fields} onSubmit={handleSubmit}/>
                    </div>
                </Spin>
            </Card>
          }
        </div>

    )
}

const LabEdit = styled(LabEditComponent)`

`

const mapStateToProps = (state: AppState,ownProps: any) => ({
  lab: state.base.lab,
  isLoading: state.base.isLoading
});

const mapDispatchToProps = (dispatch:any) => {
    return {
        onUpdate: (data :any) => dispatch(updateLaboratory(data))
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(LabEdit));